import axios from 'axios';

const DEFAULT_TIMEOUT_MS = Number(process.env.REACT_APP_API_TIMEOUT_MS || 120000);
const LONG_REQUEST_TIMEOUT_MS = Number(process.env.REACT_APP_API_LONG_TIMEOUT_MS || 900000);
export const AUTH_TOKEN_STORAGE_KEY = 'zentis-token';

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  timeout: DEFAULT_TIMEOUT_MS,
});

export function getStoredAuthToken() {
  if (typeof localStorage === 'undefined') return null;
  return localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
}

export function setApiAuthToken(token) {
  if (token) {
    API.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
    }
  } else {
    delete API.defaults.headers.common['Authorization'];
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
    }
  }
}

API.interceptors.request.use((config) => {
  const token = getStoredAuthToken();
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function withTimeout(timeoutMs = LONG_REQUEST_TIMEOUT_MS) {
  return { timeout: timeoutMs };
}

export function isTimeoutError(error) {
  return error?.code === "ECONNABORTED" || /timeout/i.test(error?.message || "");
}

export default API;
